import { parse, format } from 'date-fns';

const UglySerializer = values => ({
  data: {
    patient_uid: values.patient_id,
    event_date: `${format(parse(values.eventDate), 'YYYY-MM-DD')}T${values.eventTime ? values.eventTime : '00:00'}:00.000Z`,
    event_time_zone: values.eventTimeZone && values.eventTimeZone.label,
    notes: values.note,
    note_is_internal: false,
    facility_uid: values.facility && values.facility.id,
    status_uid: values.status && values.status.id,
    reason_uid: values.reason && values.reason.id,
    provider_uid: values.provider && values.provider.id,
    provider_location_uid: undefined,
    medical_event_uid: values.medicalEvent.id,
    is_home_address: values.isHomeAddress && values.isHomeAddress === 'yes',
    addr1: values.address1,
    city: values.city,
    county: values.county,
    location_name: values.locationName,
    province_iso: values.state && values.state.attributes.divisionAbbrevIso,
    addr2: values.addr2,
    post_code: values.postCode && values.postCode.toString(),
    detail_object: JSON.stringify({
      humanInteractions: values.humanInteractions,
      kitsDistributed: values.kitsDistributed !== '' ? values.kitsDistributed : undefined,
      ftStripsDistributed: values.ftStripsDistributed !== '' ? values.ftStripsDistributed : undefined,
      xyStripsDistributed: values.xyStripsDistributed !== '' ? values.xyStripsDistributed : undefined,
      providers: values.responseTeam && values.responseTeam.map(p => p.id),
      referToRole: values.referToRole && values.referToRole.value,
      naloxoneAdministered:
        values.naloxoneAdministered,
      naloxoneAdministeredBy:
        values.naloxoneAdministeredBy,
      routeOfNaloxoneAdministration:
        values.routeOfNaloxoneAdministration,
      amountOfNaloxoneGiven:
        values.amountOfNaloxoneGiven !== '' ? values.amountOfNaloxoneGiven : undefined,
      wasOverdoseFatal:
        values.wasOverdoseFatal,
      acceptedTreatment:
        values.acceptedTreatment,
      wasTransportedToHospital:
        values.wasTransportedToHospital,
      contactAttemptType:
        values.contactAttemptType,
      contactPhase: values.contactPhase,
      survivorContacted:
        values.survivorContacted,
      leftFlyer: values.leftFlyer,
      doScheduleAnother:
        values.doScheduleAnother,
      nextInteractionDate:
        values.nextInteractionDate &&
        parse(values.nextInteractionDate).toISOString(),
      otherContactType:
        values.otherContactType && values.otherContactType.value,
      otherContactName: values.otherContactName,
      otherContactPhone: values.otherContactPhone && values.otherContactPhone !== '' ? values.otherContactPhone.replace(/\D/g, '') : undefined,
      type: values.type,
      name: values.name,
      method: values.method,
      outcome: values.outcome && values.outcome.attributes.medicalEventOutcomeName,
      outcomeDate: values.outcomeDate && parse(values.outcomeDate).toISOString(),
    }),
  },
});

export default UglySerializer;
